function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .335h74.658v43.83H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M.29 0h48.908V68.66H.289z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(899 140)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.997 30.76A1.61 1.61 0 000 32.272a1.607 1.607 0 001.03 1.48l26.773 10.414L74.658.332.997 30.76z",
  fill: "#89A894",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(928.38 142.29)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.322 45.117l-.033-.032v21.962c0 .884.723 1.612 1.634 1.612.572 0 1.115-.296 1.412-.8l10.742-18.175 19.741 10.71a1.64 1.64 0 001.464.058c.468-.213.81-.626.919-1.129L49.2 0 .322 45.117z",
  fill: "#89A894",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M920.378 192.68c-99.585 98-99.585 57.667 0-121C1019.964-106.985 713.504 48.348 1 537.68",
  stroke: "#89A894",
  strokeWidth: 2,
  strokeDasharray: "5,25,80"
}));

function SvgDart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 978 539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.d1b9fb31.svg";
export { ForwardRef as ReactComponent };